export default {
  'userandregister.login.userName': '用户名',
  'userandregister.login.password': '密码',
  'userandregister.login.message-invalid-credentials': '账户或密码错误（admin/ant.design）',
  'userandregister.login.message-invalid-verification-code': '验证码错误',
  'userandregister.login.tab-login-credentials': '账户密码登录',
  'userandregister.login.tab-login-mobile': '手机号登录',
  'userandregister.login.remember-me': '自动登录',
  'userandregister.login.forgot-password': '忘记密码',
  'userandregister.login.sign-in-with': '其他登录方式',
  'userandregister.login.signup': '注册账户',
  'userandregister.login.login': '登录',
  'userandregister.register.register': '注册',
  'userandregister.register.get-verification-code': '获取验证码',
  'userandregister.register.sign-in': '使用已有账户登录',
  'userandregister.register-result.msg': '你的账户：{email} 注册成功',
  'userandregister.register-result.activation-email':
    '激活邮件已发送到你的邮箱中，邮件有效期为24小时。请及时登录邮箱，点击邮件中的链接激活帐户。',
  'userandregister.register-result.back-home': '返回首页',
  'userandregister.register-result.view-mailbox': '查看邮箱',
  'userandregister.email.required': '请输入邮箱地址！',
  'userandregister.email.wrong-format': '邮箱地址格式错误！',
  'userandregister.userName.required': '请输入用户名!',
  'userandregister.password.required': '请输入密码！',
  'userandregister.password.twice': '两次输入的密码不匹配!',
  'userandregister.strength.msg': '请至少输入 6 个字符。请不要使用容易被猜到的密码。',
  'userandregister.strength.strong': '强度：强',
  'userandregister.strength.medium': '强度：中',
  'userandregister.strength.short': '强度：太短',
  'userandregister.confirm-password.required': '请确认密码！',
  'userandregister.phone-number.required': '请输入手机号！',
  'userandregister.phone-number.wrong-format': '手机号格式错误！',
  'userandregister.verification-code.required': '请输入验证码！',
  'userandregister.title.required': '请输入标题',
  'userandregister.date.required': '请选择起止日期',
  'userandregister.goal.required': '请输入目标描述',
  'userandregister.standard.required': '请输入衡量标准',
  'userandregister.form.get-captcha': '获取验证码',
  'userandregister.captcha.second': '秒',
  'userandregister.form.optional': '（选填）',
  'userandregister.form.submit': '提交',
  'userandregister.form.save': '保存',
  'userandregister.email.placeholder': '邮箱',
  'userandregister.password.placeholder': '至少6位密码，区分大小写',
  'userandregister.confirm-password.placeholder': '确认密码',
  'userandregister.phone-number.placeholder': '手机号',
  'userandregister.verification-code.placeholder': '验证码',
  'userandregister.title.label': '标题',
  'userandregister.title.placeholder': '给目标起个名字',
  'userandregister.date.label': '起止日期',
  'userandregister.placeholder.start': '开始日期',
  'userandregister.placeholder.end': '结束日期',
  'userandregister.goal.label': '目标描述',
  'userandregister.goal.placeholder': '请输入你的阶段性工作目标',
  'userandregister.standard.label': '衡量标准',
  'userandregister.standard.placeholder': '请输入衡量标准',
  'userandregister.client.label': '客户',
  'userandregister.label.tooltip': '目标的服务对象',
  'userandregister.client.placeholder': '请描述你服务的客户，内部客户直接 @姓名／工号',
  'userandregister.invites.label': '邀评人',
  'userandregister.invites.placeholder': '请直接 @姓名／工号，最多可邀请 5 人',
  'userandregister.weight.label': '权重',
  'userandregister.weight.placeholder': '请输入',
  'userandregister.public.label': '目标公开',
  'userandregister.label.help': '客户、邀评人默认被分享',
  'userandregister.radio.public': '公开',
  'userandregister.radio.partially-public': '部分公开',
  'userandregister.radio.private': '不公开',
  'userandregister.publicUsers.placeholder': '公开给',
  'userandregister.option.A': '同事甲',
  'userandregister.option.B': '同事乙',
  'userandregister.option.C': '同事丙',
  'userandregister.navBar.lang': '语言',
};
